module.exports = "<p>clinicprocedure works!</p>\n"